import { useViewportSize } from "@mantine/hooks";

import useStyles from "_styles/pages/blogs/categoryPostLayout.js";

import CategoryPost from "./categoryPost";

const CategoryPostLayout = ( { category } ) => {
	const { width }      = useViewportSize ();
	let deviceViewTab    = width && width <= 1250;
	let deviceMobileView = width && width <= 600;
	const { classes }    = useStyles ( { deviceViewTab, deviceMobileView } );

	const categoryPosts = [];

	category?.posts?.forEach ( post => {
		let postSchema = {
			...post,
			categoryName: category?.name
		};

		categoryPosts.push ( postSchema );
	} );

	return (
		<div className = { classes.categoryPostLayout }>

			{
				categoryPosts?.slice ( 0, 3 ).map ( post => {

					return (
						<CategoryPost
							key = { post?.id }
							post = { post }
						/>
					);
				} )
			}

		</div>
	);
};

export default CategoryPostLayout;
